<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17LburQ/tc-custom/9783968655529.jpg?1703128691475" alt="This image is the cover for the book Der Zinker, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Der Zinker, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Der Zinker (Originaltitel: The Squeaker) ist ein Kriminalroman und ein Bühnenstück des englischen Schriftstellers Edgar Wallace. Der Zinker ist ein gefürchteter Hehler in der Londoner Unterwelt. Er erpresst Gauner, die ihm gestohlene Ware für einen Bruchteil des wahren Wertes verkaufen müssen. Andernfalls werden die Ganoven bei Scotland Yard „verzinkt“, also denunziert. Eines Tages kommt es zu einem Mord, der auf das Konto des Zinkers geht. Die Spur führt die Inspektoren Elford und Barrabal zu der Import-Export-Firma von Frank Sutton. Auch der Reporter Josua Harras wittert eine große Chance und heftet sich an die Fährte des Zinkers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edgar Wallace
      </h2>
      
      <p class="authorDescription body article">Richard Horatio Edgar Wallace (* 1. April 1875 in Greenwich bei London; † 10. Februar 1932 in Hollywood, Kalifornien) war ein englischer Schriftsteller, Drehbuchautor, Regisseur, Journalist und Dramatiker. Er gehört zu den erfolgreichsten englischsprachigen Kriminalschriftstellern.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21555b42